module.exports = __webpack_public_path__ + "img/home-icon-9.f32de985.png";